// Keep project descriptions and destinations shared by the portfolio and footer.
const projects = [
  {
    id: "onlygoodnews",
    name: "OnlyGoodNews",
    category: "Community newspaper",
    title: "Your good news deserves a headline.",
    description:
      "OnlyGoodNews is a newspaper for life's little joys. Share a personal win, celebrate an act of kindness, or enjoy a comic in a community edition filled with reasons to smile.",
    icon: "newspaper",
    color: "#9d7418",
    background: "#fff6df",
    href: "https://onlygoodnews.online",
  },
  {
    id: "manywithin",
    name: "ManyWithin",
    category: "Collective art",
    title: "Individual stories. One shared artwork.",
    description:
      "ManyWithin brings photos and personal stories into a collective canvas. Each contribution becomes an artistic interpretation, joining others in a shared reveal.",
    icon: "palette",
    color: "#765137",
    background: "#f5eee5",
    href: "https://manywithin.com",
  },
  {
    id: "bripplex",
    name: "Bripplex",
    category: "Community data",
    title: "A connected view of the world.",
    description:
      "Bripplex connects people who share mobile sensor data with those who need it. A community-powered approach to collecting and exploring data from the world around us.",
    icon: "sensors",
    color: "#176a74",
    background: "#e8f3f4",
    href: "https://bripplex.com",
  },
  {
    id: "vowcanvas",
    name: "VowCanvas",
    category: "Personal commitments",
    title: "Make a promise. Make it visible.",
    description:
      "VowCanvas turns the moments you capture while keeping a promise into a photographic mosaic. Choose a meaningful picture and watch your commitment take shape, one moment at a time.",
    icon: "favorite_border",
    color: "#974a57",
    background: "#faeded",
    href: "https://vowcanvas.app",
  },
  {
    id: "infinite-worlds",
    name: "Infinite Worlds",
    category: "Interactive art & exploration",
    title: "Every world opens another possibility.",
    description:
      "An exploration of collectible journeys through interconnected art worlds. Discover hidden gates, follow artists’ stories, and build a personal path through immersive scenes.",
    icon: "explore",
    color: "#62548d",
    background: "#efedf7",
    status: "In development",
  },
];

export default projects;
